import React from 'react';
import PropTypes from 'prop-types';

import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEInfoViewItemView from './oe-info-view-item-view';
import OEPlyr from '../../elements/oe-plyr';
import retardUpdate from '../../../lib/react/update-retarder';

export default class OEInfoViewItemTutorials extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                title: 'Tutorials',
                startViewBtn: 'Show Tutorial',
                toolsAndFunctionsLabel: 'Tools and Functions'
            },
            videos: []
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onStartViewBtn = this.onStartViewBtn.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;
        let videos = [];
        for(let i = 1; i < 10; ++i) {
            videos.push(si.getLocalizedStringEnc('tutorial_video_' + i.toString() + '_youtube'));
        }

        this.setState({ 
            strings: {
                title: si.getLocalizedStringEnc('info_view_tutorials_label'),
                startViewBtn: si.getLocalizedStringEnc('info_view_tutorials_start_view_button'),
                toolsAndFunctionsLabel: si.getLocalizedStringEnc('info_view_tutorials_tools_functions_label')
            },
            videos: videos
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
        });
    }

    render() {
        const videos = this.state.videos.map((src, index) => <OEPlyr key={index} style={{paddingTop: index > 0 ? '15px' : '0px'}} src={src}/>);

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEInfoViewItemView
                    moduleId={this.props.moduleId}
                    elementRef={this.props.elementRef}
                    isMaximizeable={true}
                    isMaximized={this.props.isMaximized}
                    notMinimizeable={this.props.notMinimizeable}
                    hasSeparator={this.props.hasSeparator}
                    className="ivi-tutorials"
                    title={this.state.strings.title}
                    onToggle={this.props.onToggle}
                    onAnimFinished={this.props.onAnimFinished}
                >
                    <div className="tutorials-container">

                        <a className="btn gray-btn tutorials-start-view-btn" role="button" onClick={this.onStartViewBtn}>
                            {this.state.strings.startViewBtn}
                        </a>
                        
                        <div className="info-view-item-separator std-label-text-color-bg"/>
                        
                        <span className = "tutorials-tools-functions-label" >{this.state.strings.toolsAndFunctionsLabel}</span>

                        {videos}

                    </div>

                </OEInfoViewItemView>
            </React.Fragment>
        );
    }

    onStartViewBtn() {
        if(typeof(this.props.appComponent.uiLayer.infoView) === 'object')   {
            this.props.appComponent.uiLayer.infoView.setOpen(false);
        }

        if(typeof(this.props.appComponent.uiLayer.startView) === 'object')   {
            this.props.appComponent.uiLayer.startView.setOpen(true);
        }
    }
}

OEInfoViewItemTutorials.defaultProps = {
    moduleId: '',
    elementRef: '',
    isMaximized: false,
    notMinimizeable: false,
    hasSeparator: true
};

OEInfoViewItemTutorials.propTypes = {
    moduleId: PropTypes.string,
    isMaximized: PropTypes.bool,
    notMinimizeable: PropTypes.bool,
    hasSeparator: PropTypes.bool
};